import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const images = [
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/feb84a2a99fbcd7e8ff78c3e17f09320.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/7bf14301ee7a6b604645c9ec2aebae83.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/567ae914b096be40c10eb487428e7174.jpeg",
  "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/a2515f1fc094fd8ff5b758d413294b54.jpeg",
];

const photos = [
  { alt: "réparation coffre volet roulant Strasbourg" },
  { alt: "coffre bloc-baie volet roulant Bas-Rhin" },
  { alt: "technicien réparation coffre volet roulant Strasbourg" },
  { alt: "coffre extérieur volet roulant linteau Bas-Rhin" },
  { alt: "coffre intégré maçonnerie volet roulant Strasbourg" },
  { alt: "remplacement joint coffre volet roulant Bas-Rhin" },
];

export default function Galerie() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Nos réalisations sur coffre de volet roulant
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {photos.map((photo, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-brand-border aspect-[4/3] overflow-hidden"
            >
              <ImagePlaceholder
                src={images[i]}
                alt={photo.alt}
                className="w-full h-full"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}